import { type ShapeOptions } from '@mui/material/styles';

import varnishTokens from '@allenai/varnish-theme';

import './muiThemeOverride.d';

export const shape: ShapeOptions = {
    // default: 4px
    borderRadius: 4,
    // additional Sizes
    borderRadiusXs: varnishTokens.radii.xs.value,
    borderRadiusSm: varnishTokens.radii.sm.value,
    borderRadiusMd: varnishTokens.radii.md.value,
    borderRadiusLg: varnishTokens.radii.lg.value,
    borderRadiusXl: varnishTokens.radii.xl.value,
    // Fully rounded
    borderRadiusFull: varnishTokens.radii.full.value,
};
